module.exports = __webpack_public_path__ + "img/Header_Slide_3_m@2x.4ed57153.png";